module.exports = __webpack_public_path__ + "static/media/zb.f3af4eff.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/zb.png
// module id = 2171
// module chunks = 4